/**
 * Chromium 기반 브라우저 여부를 판별하는 훅
 * Manifest V3 확장프로그램은 Chromium 기반 브라우저에서만 지원됨
 * (Chrome, Edge, Brave, Opera, Arc 등)
 */
const useIsChromium = (): boolean => {
  if (typeof window === 'undefined') return false;
  const ua = navigator.userAgent;
  // Chromium 기반 브라우저는 userAgent에 "Chrome/"를 포함
  // 단, Firefox도 일부 호환 모드에서 Chrome을 포함할 수 있으므로 제외
  return /Chrome\//.test(ua) && !/Firefox\//.test(ua);
};

export default useIsChromium;
